module.exports = __webpack_public_path__ + "media/images/icon-chart-7bc79650ccb3a1ed958e5a092e57475b.png";